import React, { createContext, useContext, useState, useRef } from 'react';

const GroupDataContext = createContext();

/** Every entity list the drawer filters, so callers can spread a full shape. */
export const EMPTY_BASELINE_LISTS = Object.freeze({
  events: [],
  resources: [],
  complexDataTypes: [],
  fhirIgs: [],
  requests: [],
  responses: [],
  commands: [],
  acknowledgements: [],
  types: [],
  auxiliaries: [],
});

export const GroupDataProvider = ({ children }) => {
  const [groupData, setGroupData] = useState({});
  const [releaseVersion, setReleaseVersion] = useState('');
  const [latestVersion, setLatestVersion] = useState('');
  const [appDisabled, setAppDisabled] = useState(false);
  const [selectedSubGroup, setSelectedSubGroup] = useState('');
  const [lastDashboardPath, setLastDashboardPath] = useState('/dashboard');
  const [releaseNotes, setReleaseNotes] = useState('');
  // The unfiltered entity lists exactly as the group payload returned them, kept
  // per (group, release). Sub data group selection filters this baseline in the
  // client instead of refetching, so clearing a level restores the wider list
  // with no network call. `fhirIgs` is stored already normalized.
  const baselineListsRef = useRef(EMPTY_BASELINE_LISTS);

  return (
    <GroupDataContext.Provider
      value={{
        groupData,
        setGroupData,
        releaseVersion,
        setReleaseVersion,
        releaseNotes,
        setReleaseNotes,
        latestVersion,
        setLatestVersion,
        appDisabled,
        setAppDisabled,
        selectedSubGroup,
        setSelectedSubGroup,
        lastDashboardPath,
        setLastDashboardPath,
        baselineListsRef,
      }}
    >
      {children}
    </GroupDataContext.Provider>
  );
};

export const useGroupData = () => useContext(GroupDataContext);
